import { ifAuthenticated, ifNotAuthenticated } from "@/router";

export default [
  {
    path: "/login",
    name: "login",
    beforeEnter: ifNotAuthenticated,
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/auth/Login.vue")
  },
  {
    path: "/access-denied",
    name: "accessDenied",
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "accessDenied" */ "@/views/auth/AccessDenied.vue")
  }
];
